import { capitalize } from "lodash/string";
import { ActionsModalNames } from "../../../../../components/ActionsModal";
import { consts } from "../../../../../shim/jsbridge";
import { isValidSha1Hash } from "../../../../../utils";
import { objectValues } from "../../../util";
import { SUBSCRIBE } from "../consts";

const { max_number_subscription_hashes: maxNumberOfSubscriptionHashes } =
  consts || {};

const mapHashes = (action, selectedRows = []) =>
  objectValues(selectedRows)
    .filter(item => item.sample?.sha1 || isValidSha1Hash(item.sample?.sha1))
    .map(item =>
      action === SUBSCRIBE
        ? {
            sha1: item.sample?.sha1,
            available: true,
            location: "local"
          }
        : item.sample?.sha1
    );

export const createBulkSubscriptionAction = (
  action,
  modalName,
  onToggleModal,
  selectedRows = []
) => {
  const hashes = mapHashes(action, selectedRows);
  return {
    label: `${capitalize(action)}${
      selectedRows?.length > maxNumberOfSubscriptionHashes
        ? ` (up to ${maxNumberOfSubscriptionHashes})`
        : ""
    }`,
    disabled: !hashes.length,
    onClick: () => {
      onToggleModal({
        show: true,
        modalName,
        modalData: {
          subscriptionHashes: hashes,
          action
        }
      });
    }
  };
};

export const createSingleSubscriptionAction = (
  action,
  modalName,
  onToggleModal,
  subscriptionSha1
) => ({
  label: capitalize(action),
  onClick: () => {
    const subscriptionData = {
      sha1: subscriptionSha1,
      available: true,
      location: "local"
    };
    onToggleModal({
      show: true,
      modalName,
      modalData: {
        subscriptionHashes: [
          action === SUBSCRIBE ? subscriptionData : subscriptionSha1
        ],
        action
      }
    });
  }
});

export const createApplyTagsAction = (selectedRows = [], onToggleModal) => {
  const hashes = objectValues(selectedRows)
    .filter(item => item.sample?.sha1 || isValidSha1Hash(item.sample?.sha1))
    .map(item => item.sample?.sha1);
  return {
    label: "Apply Tags",
    onClick: () => {
      onToggleModal({
        show: true,
        modalName: ActionsModalNames.ApplyTags,
        modalData: {
          hashes
        }
      });
    }
  };
};
